import {RTCUserMark, UserType} from "@/ts/Enum";

/**
 * rtc活动基本信息
 */
export default class RtcChannel {
    /**
     * rtc频道对应的活动ID
     */
    activity_id: string
    /**
     * rtc频道ID，即课堂ID码
     */
    channel_id: string
    /**
     * 用户在rtc直播间内的展示名称。
     * 登录用户为自身在平台内的用户名，非登录用户为加入直播见时手动输入的用户名
     */
    display_name: string
    /**
     * 用户在rtc直播间内的用户ID
     */
    user_id: string
    /**
     * 用户的身份
     */
    user_type: string
    /**
     * 用户名的前缀
     */
    user_mark: string
    /**
     * rtc活动发起人名称
     */
    teacher_name: string
    /**
     * rtc活动发起人Id
     */
    teacher_id: number

    constructor(activity_id: string, channel_id: string,
                display_name: string, user_id: string,
                user_type: string, user_mark: string,
                teacher_name: string, teacher_id: number) {
        this.activity_id = activity_id
        this.channel_id = channel_id
        this.user_id = user_id
        this.display_name = display_name
        this.user_type = user_type
        this.user_mark = user_mark
        this.channel_id = channel_id;
        this.teacher_name = teacher_name;
        this.teacher_id = teacher_id;

    }

}
